const publicationEndpoints = {
  createPublication: { method: "POST", path: "/publications" },
  updatePublication: (publicationId) => ({
    method: "PATCH",
    path: `/publications/${publicationId}`,
  }),
  deletePublication: (publicationId) => ({
    method: "DELETE",
    path: `/publications/${publicationId}`,
  }),
  getPublications: { method: "GET", path: "/publications" },
  getMyPublications: { method: "GET", path: "/publications/me" },
  publishPublication: (publicationId) => ({
    method: "PATCH",
    path: `/publications/${publicationId}/publish`,
  }),
  unpublishPublication: (publicationId) => ({
    method: "PATCH",
    path: `/publications/${publicationId}/unpublish`,
  }),
  getPublication: (publicationId) => ({
    method: "GET",
    path: `/publications/${publicationId}`,
  }),
  getDraft: (publicationId) => ({
    method: "GET",
    path: `/publications/${publicationId}/draft`,
  }),
  likePublication: (publicationId) => ({
    method: "POST",
    path: `/publications/${publicationId}/likes`,
  }),
  unlikePublication: (publicationId) => ({
    method: "DELETE",
    path: `/publications/${publicationId}/likes`,
  }),
  isLikedByMe: (publicationId) => ({
    method: "GET",
    path: `/publications/${publicationId}/likes/me`,
  }),
  createComment: (publicationId) => ({
    method: "POST",
    path: `/publications/${publicationId}/comments`,
  }),
  deleteComment: (publicationId, commentId) => ({
    method: "DELETE",
    path: `/publications/${publicationId}/comments/${commentId}`,
  }),
  getComments: (publicationId) => ({
    method: "GET",
    path: `/publications/${publicationId}/comments`,
  }),
  resolvePath: { method: "GET", path: "/publications/resolve-path" },
};

export default publicationEndpoints;
